// import { Extension } from "@tiptap/core";

// export const ForceFirstNodeH1 = Extension.create({
//   name: "forceFirstNodeH1",

//   // This runs whenever the doc is updated
//   onUpdate({ editor }) {
//     const firstNode = editor.state.doc.firstChild;

//     if (!firstNode) return;

//     if (firstNode.type.name !== "heading" || firstNode.attrs.level !== 1) {
//       editor.commands.command(({ tr, state }) => {
//         tr.setNodeMarkup(0, state.schema.nodes.heading, { level: 1 });
//         return true;
//       });
//     }
//   },
// });

import { Extension } from "@tiptap/core";
import { Plugin } from "prosemirror-state";

export const ForceFirstNodeH1 = Extension.create({
  name: "forceFirstNodeH1",

  addProseMirrorPlugins() {
    return [
      new Plugin({
        appendTransaction(transactions, oldState, newState) {
          // Guard: avoid loops if our own fix triggers another update
          if (transactions.some((tr) => tr.getMeta("forceFirstNodeH1"))) {
            return null;
          }

          const first = newState.doc.firstChild;

          // If doc is empty, create an H1
          if (!first) {
            const tr = newState.tr.insert(
              0,
              newState.schema.nodes.heading.create({ level: 1 })
            );
            tr.setMeta("forceFirstNodeH1", true);
            tr.setMeta("addToHistory", false);
            return tr;
          }

          // If first node isn't H1, convert it
          if (first.type.name !== "heading" || first.attrs.level !== 1) {
            const tr = newState.tr.setNodeMarkup(
              0, // first top-level node starts at pos 0
              newState.schema.nodes.heading,
              { level: 1 }
            );
            tr.setMeta("forceFirstNodeH1", true);
            tr.setMeta("addToHistory", false);
            return tr;
          }

          return null;
        },
      }),
    ];
  },
});
